<template>
    <div>
        <div class="form__item">
            <span class="title title--s title--uppercase">{{ $lang('reset.title') }}</span>
            <span class="popup__header-description" v-html="$lang('reset.description')"></span>
        </div>
        <el-tabs :active-name="tab" class="popup__tabs" @tab-click="clearError">
            <el-tab-pane :label="$lang('reset.byEmail')" name="email">
                <div style="padding: 2rem;">
                    <errors :errors="errors"></errors>
                    <form class="form" @submit.prevent="reset('email')">
                        <div class="form__item">
                            <label class="form__inner">
                                <span class="form__label">{{ $lang('reset.label.email') }}</span>
                                <el-input class="input input--big" placeholder="email@info.com" v-model="email" required></el-input>
                            </label>
                        </div>
                        <div class="form__item">
                            <button class="btn btn--middle btn--main-bg">{{ $lang('reset.button.restore') }}</button>
                        </div>
                        <div class="form__item form__item--inline">
                            <span class="popup__auth-hint">{{ $lang('reset.hint') }}</span> <button class="btn link" @click.prevent="setType('register')"><span>{{ $lang('reset.button.register') }}</span></button>
                        </div>
                    </form>
                </div>
            </el-tab-pane>
            <el-tab-pane v-if="locale === 'ru'" :label="$lang('reset.byPhone')" name="phone">
                <div style="padding: 2rem;">
                    <errors :errors="errors"></errors>
                    <form class="form" @submit.prevent="reset('phone')">
                        <div class="form__item">
                            <label class="form__inner">
                                <span class="form__label">{{ $lang('reset.label.phone') }}</span>
                                <input-phone class="input input--big" v-model="phone" required/>
                            </label>
                        </div>
                        <div class="form__item">
                            <button class="btn btn--middle btn--main-bg">{{ $lang('reset.button.restore') }}</button>
                        </div>
                        <div class="form__item form__item--inline">
                            <span class="popup__auth-hint">{{ $lang('reset.hint') }}</span> <button class="btn link" @click.prevent="setType('register')"><span>{{ $lang('reset.button.register') }}</span></button>
                        </div>
                    </form>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import {mapActions, mapMutations, mapState } from 'vuex';
    import Errors from "../../error/errors";
    import InputPhone from "../../../components/InputPhone";

    export default {
        name: "reset",
        components: {Errors, InputPhone},
        data: () => ({
            email: '',
            phone: '',
            errors: null,
            tab: 'email',
            locale: window.laravel.locale,
            prices: window.laravel.prices,
        }),
        computed: {
            ...mapState('auth',[
                'formAuth',
                'user',
            ])
        },
        methods: {
            ...mapMutations('create', [
                'setType',
            ]),
            ...mapMutations('auth', [
                'clearData',
            ]),
            ...mapActions('auth', [
                'emailReset',
            ]),
            reset(value){
                let val = value === 'email' ? {email: this.email} : {phone: this.phone};
                this.emailReset(val)
                    .then((response) => {
                        let test = value === 'email' ? this.$lang('reset.passwordSendToEmail') : this.$lang('reset.passwordSendToPhone');
                        this.$appNotify.success(test);
                        this.setType('login');
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors;
                        console.log(error);
                    });
            },
            clearError(tab) {
                if (this.errors) {
                    this.errors = null;
                }
            }
        },
        beforeDestroy() {
            this.$nextTick(() => {
                this.clearData();
            });
        },
    }
</script>

<style scoped>

</style>
